import { css } from '@emotion/core'

const global = css`
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,700&display=swap');
`

export default global
